import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const APAddNewRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    new_url: '',
    old_url: '',
    status: '',
  });
  const [errors, setErrors] = useState({
    new_url: '',
    old_url: '',
    status: '',
  });

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + `/admin/redirects/${id}`,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setUserData(response.data);
    } catch (error) {
      setLoading(false);

      console.error('Error', error);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleClick = async e => {
    e.preventDefault();

    try {
      const newErrors = {};

      if (userData.new_url === '') {
        newErrors.new_url = 'New URL is required';
      }
      if (userData.old_url === '') {
        newErrors.old_url = 'Old URL is required';
      }
      if (userData.status === '') {
        newErrors.status = 'Status is required';
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          cancelButtonText: 'No',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          title: id ? 'Update?' : 'Create?',
          text: id ? 'Do you want to update Redirect?' : 'Do you want to create Redirect?',
        });

        if (confirmationResult.isConfirmed) {
          setLoading(true);

          if (id) {
            const response = await axios.put(
              BaseApi + `/admin/redirects/${id}`,
              userData,
              {
                headers: {
                  key: ApiKey,
                  adminid: adminID,
                  ContentType: 'application/json',
                  Authorization: `Bearer ${tokenKey}`,
                },
              },
            );

            setLoading(false);

            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                confirmButtonText: 'Close',
                title: 'Redirect updated successfully!',
              });

              navigate('/admin/redirects');
            } else {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'Close',
                title: response.data.message,
              });
            }
          } else {
            const response = await axios.post(
              BaseApi + '/admin/redirects/create',
              userData,
              {
                headers: {
                  key: ApiKey,
                  adminid: adminID,
                  ContentType: 'application/json',
                  Authorization: `Bearer ${tokenKey}`,
                },
              },
            );

            setLoading(false);

            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                confirmButtonText: 'Close',
                title: 'Redirect created successfully!',
              });

              navigate('/admin/redirects');
            } else {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'Close',
                title: response.data.message,
              });
            }
          }
        }
      }
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        confirmButtonText: 'Close',
        text: 'Could not create Redirect. Please try again later!',
      });

      console.error('Could not create Redirect!', error);
    }
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      if (id) {
        getData();
      }

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate('/admin/redirects')}
                    >
                      Redirects
                    </Link>
                    <Typography color='text.primary'>
                      {
                        id
                          ? 'Edit Redirect'
                          : 'Add New Redirect'
                      }
                    </Typography>
                  </Breadcrumbs>
                </div>
                <h2 className='adminPageHeading'>
                  {
                    id
                      ? 'Edit Redirect'
                      : 'Add New Redirect'
                  }
                </h2>
                <form className='adminForm' onSubmit={e => handleClick(e)}>
                  <div className='mb-4 mt-5'>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Old URL
                        <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='old_url'
                        name='old_url'
                        placeholder='Old URL'
                        onChange={handleChange}
                        value={userData.old_url}
                        className={`form-control ${errors.old_url && 'input-error'}`}
                      />
                      {
                        errors.old_url && (
                          <div className='text-danger'>
                            {errors.old_url}
                          </div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        New URL
                        <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='new_url'
                        name='new_url'
                        placeholder='New URL'
                        onChange={handleChange}
                        value={userData.new_url}
                        className={`form-control ${errors.new_url && 'input-error'}`}
                      />
                      {
                        errors.new_url && (
                          <div className='text-danger'>
                            {errors.new_url}
                          </div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Status
                        <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='status'
                        name='status'
                        placeholder='Status'
                        onChange={handleChange}
                        value={userData.status}
                        className={`form-control ${errors.status && 'input-error'}`}
                      />
                      {
                        errors.status && (
                          <div className='text-danger'>
                            {errors.status}
                          </div>
                        )
                      }
                    </div>
                    <div className='adminBottomButtons'>
                      <button
                        type='submit'
                        className='btn btn-primary button1'
                      >
                        {
                          id
                            ? 'Update'
                            : 'Create'
                        }
                      </button>
                      <button
                        type='button'
                        className='btn btn-primary button2'
                        onClick={() => navigate('/admin/redirects')}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )}
      </div>
    </>
  );
};

export default APAddNewRedirect;
